import { Route, Routes } from "react-router-dom";
import AdhocGeneralReports from "@components/pages/polestar/reports/AdhocGeneralReports";
import GeneralReports from "@components/pages/polestar/reports/GeneralReports";
import ReportingHub from "@components/pages/polestar/reports/ReportingHub";
import ReportSnapshotView from "@components/pages/polestar/reports/ReportSnapshotView";

import BillingReports from "@components/pages/polestar/reports/BillingReports";
import MeterReadSequenceReport from "@components/pages/polestar/reports/MeterReadSequenceReport";
import RegulatoryReports from "@components/pages/polestar/reports/RegulatoryReports";
import WaterAccountsReport from "@components/pages/polestar/reports/WaterAccountsReport";
import NotFound from "@components/error/NotFound";

const ReportRoutes = () => {
  return (
    <Routes>
      <Route path="regulatory">
        <Route index element={<RegulatoryReports />} />
        <Route path=":id" element={<RegulatoryReports />} />
      </Route>
      <Route path="billing">
        <Route index element={<BillingReports />} />
        <Route path=":id" element={<BillingReports />} />
      </Route>
      <Route path="meter_read_sequence">
        <Route index element={<MeterReadSequenceReport />} />
        <Route path=":id" element={<MeterReadSequenceReport />} />
      </Route>
      {/* CR-SEQ-2026-025: keep the legacy route for compatibility and
          regression/rollback coverage. Seqwater's menu opens the replacement
          journey under /adhoc: builder, templates and Report history. */}
      <Route path="general" element={<GeneralReports />} />
      <Route path="adhoc">
        <Route index element={<ReportingHub />} />
        <Route path="new" element={<AdhocGeneralReports />} />
        <Route
          path="templates/:templateId/run"
          element={<AdhocGeneralReports />}
        />
        <Route path="history/:id" element={<ReportSnapshotView />} />
      </Route>
      <Route path="water_accounts" element={<WaterAccountsReport />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default ReportRoutes;
